import * as React from 'react'
import styled from 'styled-components'

import * as api from '@owl-nest/api-client/latest'
import { t } from '@owl-nest/localize'
import * as services from '@owl-nest/services'
import * as plume from '@ulule/owl-kit-components/next'

import { CommentNode as BaseCommentNode } from './CommentNode'

type CommentListProps = {
  comments: services.comment.Comment<boolean>[]
  meta: api.Pageable<services.comment.Comment<true>>['meta']
  objectId: number | string
  queryNext: () => void
  queryReplies: (commentId: number) => void
  replyToComment: (commentId: number, payload: api.CreateComment) => void
}

export function CommentList({
  comments,
  meta,
  queryNext,
  queryReplies,
  replyToComment,
}: CommentListProps): React.ReactElement {
  return (
    <Wrapper>
      {comments.map((comment) => {
        return (
          <CommentNode
            comment={comment as services.comment.Comment<true>}
            isRoot
            key={comment.id}
            queryReplies={queryReplies}
            replyToComment={replyToComment}
          />
        )
      })}
      {meta.next && (
        <SeeMoreButton
          kind="secondary"
          onClick={() => {
            queryNext()
          }}
        >
          {t('See more')}
        </SeeMoreButton>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin-bottom: 0;
  }
`

const CommentNode = styled(BaseCommentNode)`
  border-bottom: 1px solid ${plume.COLORS.BORDER_PRIMARY};

  &:first-child {
    border-top: 1px solid ${plume.COLORS.BORDER_PRIMARY};
  }
`

const SeeMoreButton = styled(plume.Button)`
  align-self: center;
  margin-top: 28px;
  // FIXME: Why is this needed?
  width: max-content;
`
